import { render, staticRenderFns } from "./PersonSearchFilter.vue?vue&type=template&id=549f2f51&"
import script from "./PersonSearchFilter.vue?vue&type=script&lang=js&"
export * from "./PersonSearchFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports